const API_BASE_URL =
	import.meta.env.VITE_API_BASE || "http://localhost:3000/api";

class ApiService {
	constructor() {
		this.baseURL = API_BASE_URL;
	}

	getHeaders() {
		const token = localStorage.getItem("token");
		return {
			"Content-Type": "application/json",
			...(token && { Authorization: `Bearer ${token}` }),
		};
	}

	async request(endpoint, options = {}) {
		const url = `${this.baseURL}${endpoint}`;
		const config = {
			headers: this.getHeaders(),
			...options,
		};

		const response = await fetch(url, config);

		if (!response.ok) {
			const error = await response.json();
			throw { response: { data: error } };
		}

		return response.json();
	}

	async login(credentials) {
		return this.request("/auth/login", {
			method: "POST",
			body: JSON.stringify(credentials),
		});
	}

	async validaToken() {
		return this.request("/auth/validar-token", {
			method: "POST",
		});
	}

	async cadastrarLeads(leads) {
		return this.request("/leads", {
			method: "POST",
			body: leads,
		});
	}

	async getLeads() {
		return this.request("/leads");
	}

	async countLeadsScouter() {
		return this.request("/leads/count");
	}

	async getLeadsDay() {
		return this.request("/leads/leads-do-dia");
	}

	async getLeadsScouter(dataInicial, dataFinal, pagina, itensporpagina) {
		return this.request(
			`/leads/?dataInicial=${dataInicial}&dataFinal=${dataFinal}&pagina=${pagina}&itensporpagina=${itensporpagina}`
		);
	}

	async reSendLead(id) {
		await this.request(`/leads/reenviar/${id}`);
	}

	async syncLeadCasting() {
		return this.request("/sync", {
			method: "POST",
		});
	}

	async criarUsuario(usuario) {
		return this.request("/scouters", {
			method: "POST",
			body: JSON.stringify(usuario),
		});
	}

	async loadScouters() {
		return this.request("/admin/");
	}

	async comparaMeses() {
		return this.request("/admin/leads");
	}

	async adicionaScouter(usuario) {
		return this.request("/admin/", {
			method: "POST",
			body: JSON.stringify(usuario),
		});
	}

	async atualizarAdmin(usuario) {
		return this.request("/admin/atualizar-admin", {
			method: "PUT",
			body: JSON.stringify(usuario),
		});
	}

	async alterarSenha(usuario) {
		return this.request("/admin/alterar-senha", {
			method: "POST",
			body: JSON.stringify(usuario),
		});
	}

	async getLeadsScouterAdmin(dataInicial, dataFinal, idScouter, local, pagina, qtdPagina) {
		return this.request(
			`/admin/${idScouter}?dataInicial=${dataInicial}&dataFinal=${dataFinal}&local=${local}&qtdPagina=${qtdPagina}&pagina=${pagina}`
		);
	}

	async getLeadsAdminMes() {
		return this.request(`/admin/leads-mes?dataInicial=&dataFinal=&page=1&limit=200`);
	}

	async getRegioes(scouter) {
		return this.request(`/admin/lista-regioes?id=${scouter}`);
	}
}

export const api = new ApiService();
